function hideProductModal() {
  const productModal = document.querySelectorAll("product-modal[open]");
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener("shopify:block:select", function (event) {
  hideProductModal();
  const blockSelectedIsSlide =
    event.target.classList.contains("slideshow__slide");
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest("slideshow-component");
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener("shopify:block:deselect", function (event) {
  const blockDeselectedIsSlide =
    event.target.classList.contains("slideshow__slide");
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest("slideshow-component");
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay)
    parentSlideshowComponent.play();
});

document.addEventListener("shopify:section:load", () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector("[id^=EnableZoomOnHover]");
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement("script");
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

(function () {
  function storeRecentlyViewed(productHandle) {
    const maxProducts = 5;
    let recentlyViewed =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];

    console.log("Current recently viewed products:", recentlyViewed);

    // Only add the product if it's not already in the recently viewed list
    if (!recentlyViewed.includes(productHandle)) {
      console.log(`Adding product: ${productHandle} to recently viewed.`);

      // Add the new product at the start and limit the array length to `maxProducts`
      recentlyViewed.unshift(productHandle);
      if (recentlyViewed.length > maxProducts) {
        const removedProduct = recentlyViewed.pop();
        console.log(
          `Removed product: ${removedProduct} due to max limit of ${maxProducts}.`
        );
      }

      // Update localStorage
      localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewed));
      console.log("Updated recently viewed products:", recentlyViewed);
    } else {
      console.log(
        `Product: ${productHandle} is already in the recently viewed list.`
      );
    }
  }

  // Store the product handle when a product page is viewed
  if (window.location.pathname.includes("/products/")) {
    const productHandle = window.location.pathname.split("/products/")[1];
    console.log(`Viewing product: ${productHandle}`);
    storeRecentlyViewed(productHandle);
  }
})();

document.addEventListener("shopify:section:reorder", () => hideProductModal());

document.addEventListener("shopify:section:select", () => hideProductModal());

document.addEventListener("shopify:section:deselect", () => hideProductModal());

document.addEventListener("shopify:inspector:activate", () =>
  hideProductModal()
);

document.addEventListener("shopify:inspector:deactivate", () =>
  hideProductModal()
);



// Image and tabs //

const tabsespd = document.querySelectorAll(".tabs__btnpd");
const tabsContent = document.querySelectorAll(".tabs__bodypd");

if (tabsContent.length > 0  ) {
  function hideTabContent() {
    tabsContent.forEach((item) => {
      item.classList.remove("active");
    });

    tabsespd.forEach((item) => {
      item.classList.remove("active");
    });
  }

  function showTabContent(i = 0) {
    tabsContent[i].classList.add("active");
    tabsespd[i].classList.add("active");
  }

  hideTabContent();
  showTabContent();

  tabsespd.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      hideTabContent();
      showTabContent(index);
    });
  });
}




$('.image-tabs-slider').slick({
centerMode: false,
centerPadding: '00px',
slidesToShow:2,
arrows: false,
dots: false,
autoplay:true,
autoplaySpeed:2500,  
responsive: [
  
{
breakpoint: 750,
settings: {
arrows: false,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 1
}
}
]
});


// Banner section //




// variants-option-slider //





var swiper = new Swiper(".variants-option-slider", {
    spaceBetween: 20,
    slidesPerView: "auto",
    loop: false,
    centeredSlides: false,
    allowTouchMove: false, // Disable cursor grab/swiping
    navigation: {
      nextEl: ".swiper-button-next21",
      prevEl: ".swiper-button-prev21",
    },
     breakpoints: {
         990: {
         spaceBetween: 10,
         slidesPerView: "auto",
         centeredSlides: false,
         roundLengths: true,
        },
       600: {
         spaceBetween: 10,
         slidesPerView: 3,
         centeredSlides: true,
         roundLengths: true,
        },
       445: {
         spaceBetween: 10,
         slidesPerView: 2,
         centeredSlides: true,
         roundLengths: true,
       },
       0: {
           spaceBetween: 45,
           slidesPerView: "auto",
           centeredSlides: false,
           roundLengths: true,
       }
      }
});


// New featured collections //




